module.exports = __webpack_public_path__ + "static/media/21-mercedes.18bf91b5.jpg";